import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createSO: [],
  loading: false,
  error: null,
};

const createSOSlice = createSlice({
  name: "createSO",
  initialState,
  reducers: {
    fetchCreateSORequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreateSOSuccess: (state, action) => {
      state.loading = false;
      state.createSO = action.payload;
    },

    fetchCreateSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreateSORequest,
  fetchCreateSOSuccess,
  fetchCreateSOFailure,
} = createSOSlice.actions;

export default createSOSlice.reducer;